import { Component, OnInit } from '@angular/core';
import { NotificionesModel } from 'src/app/shared/models/mensajes/notificaciones.model';
import { SubProcesosService } from '../services/sub-procesos.service';
import { MensajesService } from '../services/mensajes.service';
import { AppMainComponent } from '../main/app.main.component';
import { ToastService } from '../services/toast/toast.service';
import { AuthenticationService } from '../login/authentication/authentication.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit {
  notificaciones: NotificionesModel[] = [];

  constructor(private sProcessService: SubProcesosService,
    private mensajesService: MensajesService,
    private msg: ToastService,
    private app: AppMainComponent,
    private auth: AuthenticationService) { }

  ngOnInit(): void {
    this.app.subjectBreadCumb.next("NOTIFICACIONES");
    this.subNotifications();
    // this.setLeidos();

  }

  subNotifications() {
    this.sProcessService.initNotification();
    this.sProcessService.subNoti().subscribe((res: any[]) => {
      const notificaciones: NotificionesModel[] = res
        .map((x: any) => this.parseNotification(x))
        .filter((x: NotificionesModel | null): x is NotificionesModel => !!x);

      if (notificaciones.length > 0) {
        this.notificaciones = notificaciones;
       // this.setLeidos();
      }
    });
  }

  private parseNotification(notification: any): NotificionesModel | null {
    if (!notification) {
      return null;
    }

    if (notification instanceof NotificionesModel) {
      return notification;
    }

    if (typeof notification === 'string') {
      try {
        return new NotificionesModel(JSON.parse(atob(notification)));
      } catch (error) {
        try {
          return new NotificionesModel(JSON.parse(notification));
        } catch {
          return null;
        }
      }
    }

    return new NotificionesModel(notification);
  }

  checkNotificacions() {
    return this.notificaciones.length > 0;
  }


  removeNotification(index: number, item: NotificionesModel) {
    this.notificaciones.splice(index, 1);
    this.sProcessService.deleteNoti(item.id_mensaje);
  }

  setLeidos() {
    var noLeidos = this.notificaciones.filter(x => !x.leido);
    noLeidos.forEach(not => {
      this.mensajesService.setLeido(not.id_mensaje, new Date().getFullYear()).toPromise().then(res => {
        const found = this.notificaciones.find(x => x.id_mensaje == not.id_mensaje);
        if (found) {
          found.leido = true;
        }
      });
    });
  }

}
